import "../edit.css";
import { Box } from "../wrapper";
import { TextAreaProps } from "./textarea.props";

export const TextArea: React.FC<TextAreaProps> = (props) => {
  return (
    <Box
      show={props.show ?? true}
      className="edit-divider"
      error={props.error}
      isDisabled={props.disabled ?? false}
    >
      <textarea
        placeholder={props.label}
        {...props}
        className={`edit-box edit-textarea ${props.className}`}
      ></textarea>
    </Box>
  );
};
